import React,{ useState, useEffect } from "react";
import './AddDay.scss';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ProgramSearchMenu from './../Search/Search';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';

import moment from 'moment';

import imgFood from '../../../assets/img/plato_demo.png';

import axios from 'axios';
import { useAuthContext } from './../../../context/authContext';

import Alert from '@mui/material/Alert';

const ProgramAddDay = ({date,menus,catalogo,catFunc,dateSelect,closeModal,updateEvents,eventList}) => {

  const { token, baseUrl } = useAuthContext();
  const [updateOrder,setUpdateOrder] = useState(false);
  const [open, setOpen] = useState(false);

  const [catNameTmp,setCatNameTmp] = useState();
  /* Que bloque se esta llenando: el buscador lo usa para marcar los platos que
     ese dia ya tiene y no ofrecerlos como si fueran nuevos. */
  const [catActual,setCatActual] = useState('lunch');

  const handleOpen = (cateogory,catName) => {
    catFunc(cateogory);
    setOpen(true);
    setCatNameTmp(catName);
    setCatActual(cateogory);
  };
  const handleClose = () => setOpen(false);

  const [dayMenu,setDayMenu] = useState({
    breakfast:[],
    dinner:[],
    lunch:[],
    snacks:[],
    drinks:[],
    /* La entrada faltaba en esta lista. CardMenu solo agrega el plato a los
       tipos que existen aqui, asi que una entrada se podia buscar pero no
       entraba al dia, y el boton ni siquiera estaba. */
    starter:[]
  });

  const removePlate = (item,cat) =>{
    const dayMenuTmp = dayMenu;
    
    let arrTmp = [];
    
    if(cat === 'breakfast'){
      arrTmp = dayMenuTmp.breakfast
      const removeItemArr = arrTmp.filter(itemFilter => itemFilter.id != item.id)
      arrTmp = removeItemArr;
      setDayMenu({...dayMenu,breakfast:arrTmp});
    }else if(cat === 'dinner'){
      arrTmp = dayMenuTmp.dinner
      const removeItemArr = arrTmp.filter(itemFilter => itemFilter.id != item.id)
      arrTmp = removeItemArr;
      setDayMenu({...dayMenu,dinner:arrTmp});
    }else if(cat === 'lunch'){
      arrTmp = dayMenuTmp.lunch
      const removeItemArr = arrTmp.filter(itemFilter => itemFilter.id != item.id)
      arrTmp = removeItemArr;
      setDayMenu({...dayMenu,lunch:arrTmp});
    }else if(cat === 'snacks'){
      arrTmp = dayMenuTmp.snacks
      const removeItemArr = arrTmp.filter(itemFilter => itemFilter.id != item.id)
      arrTmp = removeItemArr;
      setDayMenu({...dayMenu,snacks:arrTmp});
    }else if(cat === 'drinks'){      
      arrTmp = dayMenuTmp.drinks
      const removeItemArr = arrTmp.filter(itemFilter => itemFilter.id != item.id)
      arrTmp = removeItemArr;
      setDayMenu({...dayMenu,drinks:arrTmp});
    }else if(cat === 'starter'){
      arrTmp = dayMenuTmp.starter
      const removeItemArr = arrTmp.filter(itemFilter => itemFilter.id != item.id)
      arrTmp = removeItemArr;
      setDayMenu({...dayMenu,starter:arrTmp});
    }
  }

  const [loadForm,setLoadForm] = useState(false);

  const [errorSend,setErrorSend] = useState(false);
  /* El servidor rechaza quitar un plato que algun cliente ya eligio, y dice
     cual. Ese texto vale mas que "revise los datos". */
  const [motivo,setMotivo] = useState('');

  const sendRequest = () =>{
    /* Si el dia ya tenia menu y no se pudo leer, guardar lo borraria: el
       servidor reemplaza el dia entero con lo que llegue. Mejor no dejar
       guardar que dejar el dia en blanco. */
    if (updateOrder && !cargoElDia) {
      setMotivo('No pudimos leer lo que ya tiene este día. Vuelve a abrirlo antes de guardar.');
      setErrorSend(true);
      return;
    }
    setMotivo('');
    setLoadForm(true);
    let arrTmp = [];

    /* El orden importa: la posicion dentro del dia es el numero de opcion
       que ve el cliente y que lee cocina. Se manda como estan cargados todos
       los demas dias —almuerzos, cenas, y al final lo que acompana— para que
       un dia tocado hoy no quede numerado distinto que el de ayer. */
    [dayMenu.lunch, dayMenu.dinner, dayMenu.breakfast,
     dayMenu.drinks, dayMenu.snacks, dayMenu.starter].forEach((lista) => {
      lista.forEach((item) => {
        item.menuTypes.forEach((menuType) => arrTmp.push(menuType.id));
      });
    });

    /* Sin repetidos. Un plato que esta cargado como almuerzo Y como cena trae
       los dos ids, asi que recorrer las dos listas lo mandaba dos veces y el
       servidor rechazaba el dia entero con "No puedes registrar el mismo menu
       para esta fecha". */
    arrTmp = [...new Set(arrTmp)];

    const dateSlot = moment(dateSelect.start).format('YYYY-MM-DD');

    
    if(updateOrder){

      axios.post(baseUrl+'menu/schedule',
        {
          menuTypeIds: arrTmp,
          date: dateSlot
        },
        {
          headers: {"Authorization" : `Bearer ${token}`}
        }
      ).then((resp)=>{
        
        setLoadForm(false);
        updateEvents();
        closeModal();
      }).catch((err)=>{
        setLoadForm(false);
        setMotivo(err?.response?.data?.message || '');
        setErrorSend(true)
      })
    } else{
      axios.post(baseUrl+'menu/schedule',
        {
          menuTypeIds: arrTmp,
          date: dateSlot
        },
        {
          headers: {"Authorization" : `Bearer ${token}`}
        }
      ).then((resp)=>{
        updateEvents();
        closeModal();
        setLoadForm(false);
      }).catch((err)=>{
        setLoadForm(false);
        setMotivo(err?.response?.data?.message || '');
        setErrorSend(true)
      })
    }
  }

  /* Lo que el dia YA tiene programado.
     El modal arrancaba vacio aunque el dia estuviera lleno, y "Enviar" manda
     la lista completa: agregar una entrada a un dia ya armado lo dejaba con
     la entrada sola. Paso el 02-10-2026 con el lunes 5, que los clientes ya
     habian elegido. Ahora se precarga y lo que se manda es lo que hay mas lo
     que se agrego. */
  const [cargoElDia,setCargoElDia] = useState(false);

  const cargarDiaActual = () => {
    if (!dateSelect) return;
    const fecha = moment(dateSelect.start).format('YYYY-MM-DD');
    axios.get(`${baseUrl}menu/schedule?startDate=${fecha}&endDate=${fecha}`,
      { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        const lista = r.data?.data || [];
        const dia = lista.find((d) => d.localDate === fecha);
        const cargado = { breakfast:[], dinner:[], lunch:[], snacks:[], drinks:[], starter:[] };
        (dia?.menuTypeGroups || []).forEach((grupo) => {
          (grupo.menuTypes || []).forEach((mt) => {
            if (!cargado[grupo.type]) return;
            cargado[grupo.type].push({
              id: mt.id,
              name: mt.menu?.name,
              imageUrl: mt.menu?.imageUrl,
              /* Solo SU id: si se mandaran todos los tipos del plato, agregar
                 un almuerzo arrastraria tambien su cena. */
              menuTypes: [{ id: mt.id }],
            });
          });
        });
        setDayMenu(cargado);
        setCargoElDia(true);
        /* Si el dia trajo algo, esto es una edicion. Antes se adivinaba
           comparando fechas convertidas a texto contra la lista de eventos del
           calendario, que es fragil y dependia de otra pantalla. */
        setUpdateOrder(Object.values(cargado).some((l) => l.length > 0));
      })
      .catch(() => setCargoElDia(false));
  };

  const getEvent = ()=>{

    const test = eventList.filter((el)=> {

      if(String(el.start) ===  String(dateSelect.start)){
        //console.log('===>')
        setUpdateOrder(true);
        return true;
      }else{
        return false;
      }
      
    })

  }

  useEffect(()=>{
    getEvent();
    cargarDiaActual();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  
  /* Los bloques en el orden en que se arma un día: primero lo que se cocina,
     después lo que acompaña. El desayuno va último porque casi nunca se usa, y
     estaba ocupando el primer lugar de la ventana. */
  const BLOQUES = [
    { cat: 'lunch',     titulo: 'Almuerzo', esperado: 3 },
    { cat: 'dinner',    titulo: 'Cena',     esperado: 3, copiaDe: 'lunch' },
    { cat: 'starter',   titulo: 'Entrada',  esperado: 1 },
    { cat: 'drinks',    titulo: 'Bebida',   esperado: 1 },
    { cat: 'snacks',    titulo: 'Snack',    esperado: 1 },
    { cat: 'breakfast', titulo: 'Desayuno', esperado: 0 },
  ];

  /* El mismo plato en su otra versión. Cada plato está cargado dos veces en la
     carta —una como almuerzo y otra como cena— con ids distintos. */
  const gemelo = (item, tipo) => {
    const plato = (catalogo || []).find((m) =>
      (m.menuTypes || []).some((mt) => mt.id === item.id));
    const mt = (plato?.menuTypes || []).find((x) => x.type === tipo);
    return mt ? { id: mt.id, name: plato.name, imageUrl: plato.imageUrl, menuTypes: [{ id: mt.id }] } : null;
  };

  /* La cena es el mismo plato que el almuerzo todos los días. Copiarla a mano,
     uno por uno, era la mitad del trabajo de programar un día. */
  const copiarDelAlmuerzo = () => {
    const copia = dayMenu.lunch.map((p) => gemelo(p, 'dinner')).filter(Boolean);
    if (copia.length) setDayMenu({ ...dayMenu, dinner: copia });
  };

  const faltantes = BLOQUES
    .filter((b) => b.esperado > 0 && dayMenu[b.cat].length < b.esperado)
    .map((b) => b.titulo.toLowerCase());

  return (
    <div className="cpad">
      <h2 className="cpad__fecha">{date ? date : 'Sin fecha'}</h2>

      <div className="cpad__bloques">
        {BLOQUES.map((b) => {
          const lista = dayMenu[b.cat] || [];
          const completo = b.esperado > 0 && lista.length >= b.esperado;
          const aMedias = b.esperado > 0 && lista.length > 0 && lista.length < b.esperado;
          return (
            <section key={b.cat} className={`cpad__bloque cpad__bloque--${b.cat}`}>
              <header>
                <h5>{b.titulo}</h5>
                {b.esperado > 0 &&
                  <span className={`cpad__cuenta${completo ? ' cpad__cuenta--ok' : ''}${aMedias ? ' cpad__cuenta--falta' : ''}`}>
                    {lista.length} de {b.esperado}
                  </span>}
                <div className="cpad__acciones">
                  {b.copiaDe && dayMenu[b.copiaDe].length > 0 &&
                    <button type="button" className="cpad__copiar" onClick={copiarDelAlmuerzo}>
                      Igual que el almuerzo
                    </button>}
                  <button type="button" className="cpad__agregar"
                    onClick={() => handleOpen(b.cat, b.titulo)}>
                    Agregar <AddIcon fontSize="inherit" />
                  </button>
                </div>
              </header>

              {lista.length === 0 ? (
                <p className="cpad__vacio">Sin {b.titulo.toLowerCase()} para este día.</p>
              ) : (
                <ul className="cpad__platos">
                  {lista.map((item) => (
                    /* En fila y no en tarjeta vertical: el nombre de un plato
                       son seis u ocho palabras, y en una tarjeta angosta salía
                       partido en ocho renglones. */
                    <li key={item.id}>
                      <img src={item.imageUrl ? item.imageUrl : imgFood} alt="" />
                      <span>{item.name}</span>
                      <IconButton size="small" aria-label={`Quitar ${item.name}`}
                        onClick={() => removePlate(item, b.cat)}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          );
        })}
      </div>

      <footer className="cpad__pie">
        {errorSend &&
          <Alert severity="error" className="cpad__error">
            {motivo || 'Debe seleccionar 1 item por cada comida'}
          </Alert>}

        {/* Lo que falta, dicho antes de guardar y no después de un rechazo. */}
        {faltantes.length > 0 && !errorSend &&
          <p className="cpad__faltan">Falta {faltantes.join(', ')}.</p>}

        <Button onClick={sendRequest} variant="contained"
          className={loadForm ? 'btnPrimary btnDisabled' : 'btnPrimary'}>
          {loadForm ? 'Guardando…' : 'Guardar el día'}
        </Button>
      </footer>

      <Modal open={open} onClose={handleClose}
        aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className="cpadModalSearch">
          <ProgramSearchMenu
            menus={menus}
            dayMenu={dayMenu}
            setDayMenu={setDayMenu}
            nameCat={catNameTmp}
            yaEstan={(dayMenu[catActual] || []).map((x) => x.id)}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default ProgramAddDay;
